import React, { useCallback, useState } from "react"
import {
  ActivitySummary,
  OverviewCards,
  Tabs,
  TopLocations,
  RevenueAndEarnings,
  TopProducts,
  CategoryDistribution,
  TrackDelivery,
} from "pages/vendor/Dashbaord/components"
import { Orders } from "pages/vendor/Orders"
import { Products } from "pages/vendor/Products"
import { Coupons } from "pages/vendor/Coupons"
import { DeliveryMen } from "pages/vendor/Delivery-men"
import { Disputes } from "pages/vendor/Disputes"
import { Card, Col, Row } from "reactstrap"
import { useTranslation } from "react-i18next"
import { FilterByDateRangeModal } from "components/Extra/FilterByDateRangeModal"

export enum CurrentTapType {
  orders = "Orders",
  products = "Products",
  coupons = "Coupons",
  Deliveries = "Deliveries",
  disputes = "Disputes",
}

export const Dashboard = () => {
  const { t, i18n } = useTranslation()
    const [currentTap, setCurrentTap] = useState<CurrentTapType>(CurrentTapType.orders)

    const onchangeTabHandler = useCallback((  tab: CurrentTapType) => {
      setCurrentTap(tab)
    }, [setCurrentTap])

    const onDateRangeChange = (startDate: string, endDate: string) => {
      console.log("Selected date range:", startDate, "to", endDate)
    }

  return (
    <div className="page-content">
      <div className="container-fluid d-flex flex-column gap-4">
        <div className="mb-1">
          <h4 className="mb-sm-0 font-size-24 text-capitalize fw-semibold pb-2">
            {t("dashboard_welcome", { name: "Hamza" })}
          </h4>
          <span
            className="font-size-12 fw-semibold"
            style={{ color: "#647683" }}
          >
            {t("dashboard_trackOrder")}
          </span>
        </div>
        <FilterByDateRangeModal onDateRangeChange={onDateRangeChange} />
        <OverviewCards />
        <Card
          style={{ margin: 0 }}
          className="mini-stats-wid shadow-md rounded-3 p-3"
        >
          <Tabs onChangeHandler={onchangeTabHandler} />
          {currentTap === CurrentTapType.orders && <Orders isDashboardPage />}
          {currentTap === CurrentTapType.products && (
            <Products isDashboardPage />
          )}
          {currentTap === CurrentTapType.coupons && <Coupons isDashboardPage />}
          {currentTap === CurrentTapType.Deliveries && (
            <DeliveryMen isDashboardPage />
          )}
          {currentTap === CurrentTapType.disputes && (
            <Disputes isDashboardPage />
          )}
        </Card>
        <Row style={{ rowGap: "1.5rem" }}>
          <Col md="5">
            <Card
              style={{ height: "100%", margin: 0 }}
              className="mini-stats-wid shadow-md rounded-3 p-3"
            >
              <ActivitySummary />
            </Card>
          </Col>
          <Col md="7">
            <Card
              style={{ height: "100%", margin: 0 }}
              className="mini-stats-wid shadow-md rounded-3 p-3"
            >
              <TopLocations />
            </Card>
          </Col>
        </Row>
        <Row style={{ rowGap: "1.5rem" }}>
          <Col xl="9">
            <Card
              style={{ height: "100%", margin: 0 }}
              className="mini-stats-wid shadow-md rounded-3 p-3"
            >
              <RevenueAndEarnings />
            </Card>
          </Col>
          <Col xl="3">
            <Card
              style={{ height: "100%", margin: 0 }}
              className="mini-stats-wid shadow-md rounded-3 p-3"
            >
              <TopProducts />
            </Card>
          </Col>
        </Row>
        <Row style={{ rowGap: "1.5rem" }}>
          <Col xl="3">
            <Card
              style={{ height: "100%", margin: 0 }}
              className="mini-stats-wid shadow-md rounded-3 p-3"
            >
              <CategoryDistribution />
            </Card>
          </Col>
          <Col xl="9">
            <Card
              style={{ height: "100%", margin: 0 }}
              className="mini-stats-wid shadow-md rounded-3 p-3"
            >
              <TrackDelivery />
            </Card>
          </Col>
        </Row>
      </div>
    </div>
  )
}
